import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import PageWrapper from '/components/page-wrapper'

import HelpText from '/help/account-management-contact'
import { AppContext } from '/providers/app-context'

import Menu from '/components/account/nav-menu'
import ContactAdmin from '/components/account/contact'

const AccountManagementContact = () => {

  const navigate = useNavigate()

  const { client,user } = useContext(AppContext)

  if (!user?.permissions.client_admin) navigate("../password")

  return (
    <PageWrapper title="Account Contact" HelpText={HelpText} heading="Account Contact" menu={<Menu client={client} user={user}/>}>
      <div className='flex flex-col gap-5 overflow-y-auto'> 
        <ContactAdmin />
      </div>
    </PageWrapper>
  )
}

export default AccountManagementContact